import { css } from '@emotion/css'
import { colors, fontSize, fontWeight, spacing } from '@offerzen/pinata-shame'

const styles = {
  appliedContent: css({
    display: 'grid',
    gap: spacing.default,
  }),

  heading: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.medium,
    marginBottom: 0,
  }),

  statusMessageContainer: css({
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: spacing.default,

    '+ *': {
      marginTop: spacing.small,
    },
  }),

  applicationStatusExplanation: css({
    width: '100%',
    fontSize: fontSize.small,
    marginBottom: 0,
  }),
}

export default styles
